import {
  IMAGE_ATTACHMENT,
  VIDEO_ATTACHMENT,
  FILE_ATTACHMENT,
} from 'utils/constants';
import { TFunction } from 'next-i18next';

export interface AttachmentButton {
  tooltipTitle: string;
  title: string;
  attachmentType: string;
  iconName: string;
  dataQA: string;
}

export const getAttachmentButtons = (t: TFunction): AttachmentButton[] => [
  {
    tooltipTitle: t('Upload image'),
    title: t('IMAGES'),
    attachmentType: IMAGE_ATTACHMENT,
    iconName: 'image',
    dataQA: 'create-post-image__button',
  },
  {
    tooltipTitle: t('Add video'),
    title: t('VIDEO'),
    attachmentType: VIDEO_ATTACHMENT,
    iconName: 'content-video',
    dataQA: 'create-post-video__button',
  },
  {
    tooltipTitle: t('Upload file'),
    title: t('FILES'),
    attachmentType: FILE_ATTACHMENT,
    iconName: 'page',
    dataQA: 'create-post-file__button',
  },
];
